import { NgModule} from '@angular/core';
import { MaterialModule,MdDialogRef } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TradeRoutingModule } from './trade-routing.module';
import { TradesComponent } from './trade.component';
import { TradeDetailsComponent } from './details/details.component';
import { deleteAddressComponent } from './details/deleteAddress.component';
import { addNewAddressComponent } from './details/addNewAddress.component';
import { addNewContactComponent } from './details/addNewContact.component';
import { HttpModule ,Http} from '@angular/http';
// multilingual
import {TranslateModule,TranslateLoader,TranslateStaticLoader} from 'ng2-translate';
@NgModule({
    imports: [
   		MaterialModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TradeRoutingModule,
        TranslateModule
    ],
    declarations: [
        TradesComponent,
        TradeDetailsComponent,
        deleteAddressComponent,
        addNewAddressComponent,
        addNewContactComponent
    ],
    entryComponents: [deleteAddressComponent, addNewAddressComponent,addNewContactComponent],
    exports: [
        
    ]
})

export class TradesModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trade/trade.module.ts